export default {"src":"/_next/static/media/paystack.14375436.svg","height":21,"width":121,"blurWidth":0,"blurHeight":0};